import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './ghs-tag.css.lit';

/**
 * Tag Component
 * @element ghs-tag
 */
@customElement('ghs-tag')
export class GhsTag extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * The variant.
   * @param variant
   */
  @property({ type: String })
  variant = 'base';

  /**
   * The active status.
   * @param active
   */
  @property({ type: Boolean })
  active = false;

  /**
   * Url
   * @param url
   */
  @property({ type: String })
  url = '';

  /**
   * Target
   * @param target
   */
  @property({ type: String })
  target = '_self';

  render(): TemplateResult {
    const classes = {
      tag: true,
      [`tag--${this.variant}`]: this.variant,
      [`tag--active`]: this.active,
    };

    return html`
      <a
        href="${this.url}"
        class="${classMap(classes)}"
        target="${this.target}"
        rel="${this.target === '_blank' && 'noreferrer noopener'}"
      >
        <slot></slot>
      </a>
    `;
  }
}
